import Vue from "vue";
import VueApollo from "vue-apollo";
import { createApolloClient } from "vue-cli-plugin-apollo/graphql-client";
import { InMemoryCache } from "apollo-cache-inmemory";

// Install the vue plugin
Vue.use(VueApollo);

// Http endpoint
const httpEndpoint =
  // eslint-disable-next-line
  `${sc_config.apiUrl}/api/graphql` || "http://127.0.0.1:5040/api/graphql";

// Config
const defaultOptions = {
  httpEndpoint,
  wsEndpoint: null
};

// Call this in the Vue app file
export function createProvider(options = {}) {
  // Create apollo client

  const { apolloClient } = createApolloClient({
    ...defaultOptions,
    ...options,
    cache: new InMemoryCache()
  });

  // Create vue apollo provider
  const apolloProvider = new VueApollo({
    defaultClient: apolloClient,
    defaultOptions: {
      $query: {
        // fetchPolicy: 'cache-and-network',
      }
    },
    errorHandler(error) {
      // eslint-disable-next-line no-console
      console.log(
        "%cError",
        "background: red; color: white; padding: 2px 4px; border-radius: 3px; font-weight: bold;",
        error.message
      );
    }
  });

  return apolloProvider;
}
